import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Tasks from "components/Tasks/Tasks.js";
import ProjectMis from "components/ProjectMis/ProjectMis.js";
import AttendanceMis from "components/AttendanceMis/AttendanceMis.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import { website, server } from "variables/general.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Reports() {
  const classes = useStyles();

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <CustomTabs
            headerColor="primary"
            tabs={[
              {
                tabName: "Projects",
                tabContent: <ProjectMis />,
              },
              { tabName: "Attendance", tabContent: <AttendanceMis /> },
            ]}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
